import React, { useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { Link, useNavigate } from "react-router-dom";
import { useVendorProvider } from "../../../../../Providers/Client/Vendor";
import CustomTable from "../../../../../Components/Table";
import Back from "../../../../../Components/Back";
import { Avatar } from "@mui/material";
import { stringAvatar } from "../../../../../Utils/avatar";

const headCells = [
  {
    id: "Consultant",
    numeric: false,
    disablePadding: true,
    label: "Consultant",
  },
  {
    id: "JobTitle",
    numeric: false,
    disablePadding: false,
    label: "Job",
  },
  {
    id: "Vendor",
    numeric: false,
    disablePadding: false,
    label: "Vendor",
  },
  {
    id: "",
    numeric: false,
    disablePadding: false,
    label: "",
  },
];

export default function Consultants({ setCard }) {
  const [rows, setRows] = React.useState([]);
  const navigate = useNavigate();
  const { fetchConsultants } = useVendorProvider();

  useEffect(() => {
    fetchConsultants()
      .then((res) => {
        setRows(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const CustomRow = ({ row }) => {
    return (
      <TableRow hover>
        <TableCell component="th" scope="row" padding="none">
          <Link target="_blank" to={`/consultant/profile/${row.consultant.id}`}>
            <span className="flex flex-row items-center">
              <Avatar
                {...stringAvatar(
                  row.consultant?.firstName + " " + row.consultant?.firstName
                )}
                className="mr-2.5"
                size="large"
                src={row?.profilePhoto}
              />
              {`${row.consultant?.firstName} ${row.consultant?.lastName}`}
            </span>
          </Link>
        </TableCell>
        <TableCell align="left">
          {row.jobs?.map((el) => el.name).join(", ")}
        </TableCell>
        <TableCell align="left">{`${row.vendor?.company}`}</TableCell>
        <TableCell align="left">
          <span
            className="text-blue-400 cursor-pointer"
            onClick={() => {
              window.open(`${window.location.origin}/consultant/profile/` + row?.consultant?.id)
            }}
          >
            View Details
          </span>
        </TableCell>
      </TableRow>
    );
  };

  return (
    <>
      <Back onClick={() => {
        navigate("/dashboard")
      }} />
      <CustomTable
        title="Consultants"
        headCells={headCells}
        rows={rows}
        CustomRow={CustomRow}
      />
    </>
  );
}
